import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* © 2023 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import { styled } from '@mui/system';
import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material';
import { PROMETHEAN_BLUE, PROMETHEAN_DARK_PURPLE, PROMETHEAN_NEUTRAL_DARK_GREY, PROMETHEAN_NEUTRAL_WHITE, PROMETHEAN_PURPLE_PLUM, PROMETHEAN_TEXT, PROMETHEAN_TEXT_HEADER } from '../styles/colors/colors';
import { PROMETHEAN_TYPOGRAPHY_SMALL_TEXT, PROMETHEAN_TYPOGRAPHY_SMALL_TEXT_UPPERCASE, PROMETHEAN_TYPOGRAPHY_SUBTITLE_03 } from '../styles/typography/typography';
export var StyledAccordion = styled(Accordion)(function () {
  return {
    maxWidth: 'min-content',
    '.MuiAccordionSummary-root': {
      marginLeft: '-4px'
    },
    '&.portalAccordion-expanded': {
      maxWidth: 'none',
      '.MuiAccordionSummary-root': {
        marginBottom: 4
      }
    },
    '&.Mui-expanded:first-of-type': {
      maxWidth: 'none',
      minWidth: 'fit-content'
    },
    '&:not(:last-child)': {
      borderBottom: 0
    },
    '&:before': {
      display: 'none'
    }
  };
});
export var StyledAccordionSummary = styled(AccordionSummary)(function () {
  return _objectSpread(_objectSpread({}, PROMETHEAN_TYPOGRAPHY_SUBTITLE_03), {}, {
    color: PROMETHEAN_TEXT_HEADER,
    padding: 0,
    margin: '0 -2px',
    // border-box sizing not respected
    border: '2px solid transparent',
    minHeight: 24,
    justifyContent: 'flex-start',
    columnGap: 8,
    '&:focus-visible': {
      background: PROMETHEAN_NEUTRAL_WHITE,
      border: "2px solid ".concat(PROMETHEAN_BLUE)
    },
    '& .MuiAccordionSummary-content': {
      margin: 0,
      flexGrow: 0
    },
    '& .MuiAccordionSummary-expandIconWrapper': {
      '&.Mui-expanded': {
        transform: 'scaleY(-1)',
        color: PROMETHEAN_TEXT
      },
      '[class*="icon-"]': {
        fontSize: 16
      }
    }
  });
});
export var StyledAccordionDetails = styled(AccordionDetails)(function () {
  return {
    padding: 0,
    paddingBottom: 8,
    display: 'flex',
    flexDirection: 'column',
    rowGap: 8,
    '.EmbersLink': {
      border: '2px solid transparent',
      marginLeft: '-5px',
      padding: '0 3px',
      width: 'fit-content',
      '&:focus-visible': {
        marginLeft: '-5px !important',
        marginRight: '0px !important'
      }
    }
  };
});
export var StyledFooter = styled('div')(function () {
  return {
    '&.EmbersFooter-root.EmbersFooter-tablet': {
      '.EmbersFooter-content': {
        padding: '32px 24px',
        '.EmbersFooter-bottom': {
          flexDirection: 'column-reverse'
        }
      }
    },
    '&.EmbersFooter-root.EmbersFooter-mobile': {
      '.EmbersFooter-content': {
        padding: '24px 16px',
        '.EmbersFooter-body': {
          padding: 0,
          '.EmbersFooter-links': {
            flexDirection: 'column',
            rowGap: 24
          }
        },
        '.EmbersFooter-bottom': {
          flexDirection: 'column-reverse'
        }
      }
    },
    '&.EmbersFooter-root': _objectSpread(_objectSpread({}, PROMETHEAN_TYPOGRAPHY_SMALL_TEXT), {}, {
      width: '100%',
      backgroundColor: PROMETHEAN_NEUTRAL_WHITE,
      zIndex: 100,
      display: 'flex',
      alignItems: 'center',
      borderBottom: "8px solid ".concat(PROMETHEAN_DARK_PURPLE),
      bottom: 0,
      hr: {
        // spacing around the divider is 16 on each side, but design has a height of 0
        margin: '15px 0 16px',
        color: PROMETHEAN_NEUTRAL_DARK_GREY
      },
      '.EmbersFooter-content': {
        color: PROMETHEAN_TEXT,
        textAlign: 'left',
        padding: '40px 24px 32px',
        width: '100%',
        '.EmbersFooter-body': {
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'flex-start',
          columnGap: 40,
          rowGap: 8,
          padding: '0 24px',
          '.EmbersFooter-copyright': _objectSpread({}, PROMETHEAN_TYPOGRAPHY_SMALL_TEXT_UPPERCASE),
          '.EmbersFooter-eA': {
            cursor: 'pointer',
            height: 24,
            width: 64,
            img: {
              height: 24,
              width: 64
            },
            '&:focus-visible > img': {
              border: "2px solid ".concat(PROMETHEAN_BLUE),
              margin: '-2px',
              height: 28,
              width: 68
            }
          },
          '.EmbersFooter-links': {
            flexWrap: 'wrap',
            columnGap: 40,
            rowGap: 32,
            display: 'flex',
            flexDirection: 'row',
            '.EmbersFooter-link': {
              fontSize: 12,
              lineHeight: '20px',
              marginTop: '-2px',
              marginBottom: '-2px'
            }
          },
          '.EmbersFooter-social': {
            display: 'flex',
            alignItems: 'center',
            columnGap: 12,
            height: 20,
            listStyle: 'none',
            marginBlockStart: 0,
            marginBlockEnd: 0,
            paddingInlineStart: 0,
            '[class*="icon-"]': {
              color: PROMETHEAN_PURPLE_PLUM,
              cursor: 'pointer',
              fontSize: 20,
              '&:focus-visible': {
                border: "2px solid ".concat(PROMETHEAN_BLUE),
                margin: '-2px'
              }
            }
          }
        }
      }
    })
  };
});